
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "ArtistName2701513331",
      {"classes":{"root":"ArtistName2701513331__root","title":"ArtistName2701513331__title"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  